import {Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild} from '@angular/core';
import {NgbNav, NgbNavChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {NavTabComponent} from "../nav-tab/nav-tab.component";
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'app-nav-tabs',
    templateUrl: './nav-tabs.component.html',
    styleUrls: ['./nav-tabs.component.scss'],
    standalone: false
})
export class NavTabsComponent {
  @ContentChildren(NavTabComponent) tabs?: QueryList<NavTabComponent>;
  @ViewChild('nav') nav?: NgbNav;

  @Input() reduceHorizontalSpacing = false;
  @Input() areTabsCentered = false;
  @Input() tabCssClass?: string;
  @Input() active?: number;

  @Input() useRouterOutlet = false;
  @Input() queryParamsHandling: 'merge' | 'preserve' | undefined = undefined;

  @Output() onChange = new EventEmitter<number | undefined>();

  ngOnInit(): void {
  }


  select(id: number) {
    this.nav?.select(id);
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    this.onChange.emit(changeEvent.nextId)
  }

  trackByItemId(index: number, tab: NavTabComponent) {
    return tab.itemId;
  }


  isLastTab(tab: NavTabComponent): boolean {
    if (!this.tabs) {
      return false;
    }
    const tabsArray = this.tabs.toArray();
    return tabsArray.indexOf(tab) === tabsArray.length - 1;
  }
}